var _path, _path2, _path3, _circle, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaveMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 77,
    viewBox: "0 0 84 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8125 63.9554H65.2554C62.5637 63.9554 60.0066 64.9984 58.1225 66.8825L52.369 72.5687C49.7446 75.1594 45.4717 75.1594 42.8473 72.5687L37.0938 66.8825C35.2097 64.9984 32.619 63.9554 29.9609 63.9554H27.4375C21.8523 63.9554 17.3438 59.4806 17.3438 53.9626V17.2549C17.3438 11.737 21.8523 7.26221 27.4375 7.26221H67.8125C73.3977 7.26221 77.9062 11.737 77.9062 17.2549V53.9626C77.9062 59.4469 73.3977 63.9554 67.8125 63.9554Z",
    stroke: "#FF8AB2",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6247 34.1452C51.9543 34.1452 55.4642 30.6353 55.4642 26.3056C55.4642 21.976 51.9543 18.4663 47.6247 18.4663C43.2951 18.4663 39.7852 21.976 39.7852 26.3056C39.7852 30.6353 43.2951 34.1452 47.6247 34.1452Z",
    stroke: "#FF8AB2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0846 53.1891C61.0846 47.1328 55.062 42.2207 47.6263 42.2207C40.1906 42.2207 34.168 47.1328 34.168 53.1891",
    stroke: "#FF8AB2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 57.5,
    r: 19,
    fill: "#EA1D63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6523 61.0568L9.66568 58.0702L12.6523 55.0835",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6094 58.0703H9.74438",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.276 67.3332C24.4327 67.3332 28.6094 63.8332 28.6094 57.9998C28.6094 52.1665 24.4327 48.6665 19.276 48.6665",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveMember);
export default __webpack_public_path__ + "static/media/leaveMember.aa17985e19d324cb0d7c7688812fe2ae.svg";
export { ForwardRef as ReactComponent };